import { styled } from 'goober';
import { mediaQuery } from '@/theme/setupTheme';

// Centralized scrollable container for suggestion tables.
// Heights are tuned to the modal heights so we use more of the available space
// and avoid large gaps below tables on larger breakpoints.
export const ScrollableTableContainer = styled('div')`
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  /* Default (desktop) */
  max-height: 520px;

  ${mediaQuery('xxl', 'min')} {
    max-height: 620px;
  }

  ${mediaQuery('xl', 'max')} {
    max-height: 520px;
  }

  ${mediaQuery('lg', 'max')} {
    max-height: 460px;
  }

  ${mediaQuery('md', 'max')} {
    max-height: 420px;
  }

  ${mediaQuery('sm', 'max')} {
    max-height: 360px;
  }
`;
